<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row>
      <v-flex xs12 sm4 offset-sm4>
        <v-card>
          <v-card flat>
            <v-card-title>Login</v-card-title>
            <v-card-text>
              <v-form v-model="formValid" ref="form">
                <v-text-field
                label="Email"
                id="username"
                required
                :rules="rulesEmail"
                v-model="body.email"
                >
                </v-text-field>
                <v-text-field
                label="Password"
                id="password"
                required
                :rules="rulesPassword"
                type="password"
                v-model="body.password"
                >
                </v-text-field>
              </v-form>
              <router-link :to="{name: 'passwordResetRequest'}">Forgot My Password</router-link>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="login">Login</v-btn>
          </v-card-actions>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import Rules from '@/shared/rules'

export default {
  data () {
    return {
      body: {
        email: '',
        password: ''
      },
      formValid: true,
      rulesEmail: [
        v => !!v || 'E-mail is required',
        v => Rules.email(v)
      ],
      rulesPassword: [
        // v => Rules.password(v)
      ]
    }
  },

  methods: {
    login: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        ApiRequests.loginPost(this.body).then(r => {
          var ref = this.$route.query.referer
          if (ref === undefined) {
            this.$router.push({ name: 'home' })
            return
          }
          var split = ref.split('?')
          var path = ''
          if (split.length > 0) {
            path = split[0]
          }
          if (ref && path !== '' && !ref.includes('login')) {
            this.$router.push(ref)
            return
          }
          this.$router.push({ name: 'home' })
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}
</script>
